import { render, staticRenderFns } from "./contentTagDelete.vue?vue&type=template&id=087da6d6&"
import script from "./contentTagDelete.vue?vue&type=script&lang=js&"
export * from "./contentTagDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports